import React from 'react';

import Info from '../../components/UI/Info/Info';
import { ReactComponent as DownloadIcon } from '../../svg/get_app.svg';
import sciendo from '../../images/cmk2020-sciendo-baner.jpg';
import template from '../../assets/cmk2020-template.zip';

import classes from './Proceedings.module.scss';

const Proceedings = () => (<div className={classes.Right}>
    <h1>Conference proceedings</h1>
    <img className={classes.SciendoBaner} src={sciendo} alt="Sciendo banner"/>
    <Info>
        The CMK2020 conference proceedings are planned to be published with De Gruter Sciendo. The publication is supported by the Ministry of Science and Higher Education, and is free of charge for authors. The expected publishing date is the third quarter of 2021. All papers are expected to have DOI number, and the book will be ISBN registered.
        </Info>
    <div className={classes.Download}>
        <DownloadIcon /><a href={template}>Download proceedings article template</a>
    </div>
</div>)

export default Proceedings;